import { render, staticRenderFns } from "./jarvis.vue?vue&type=template&id=5f7675e4"
import script from "./jarvis.vue?vue&type=script&lang=js"
export * from "./jarvis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports